import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import StickyHeader from './components/common/StickyHeader';
import BottomNav from './components/common/BottomNav';

import Home from './components/Home';

import DeepLinkRedirect from './components/DeepLinkRedirect';
import DeepLinkCus from './components/DeepLinkCus';
import Download from './components/Download';


function App() {
  return (
    <Router>
      <StickyHeader />
      <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="Download" element={<Download />} />
      
      <Route path="SP/:spid" element={<DeepLinkRedirect />} />
      <Route path="CUS/:cusid" element={<DeepLinkCus />} />
      </Routes>
      <BottomNav />
    </Router>
  );
}


export default App;
